import Loadable from 'react/components/loadable';

const EditProductDrawer = Loadable({
  loader: () => import('../../pages/pos/products/edit_product'),
  type: 'drawer',
});

angular.module('gym').value('EditProductDrawer', EditProductDrawer);
